import React, { useState, useCallback, useRef } from 'react';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

const ItemType = 'BOX';

function DraggableItem({
  id, text, index, moveItem,
}) {
  const ref = useRef(null);
  const [, drop] = useDrop({
    accept: ItemType,
    hover(item) {
      if (!ref.current) return;
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) return;
      moveItem(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: ItemType,
    item: { id, index },
    collect: (monitor) => ({ isDragging: monitor.isDragging() }),
  });

  drag(drop(ref));

  return (
    <div
      ref={ref}
      style={{
        opacity: isDragging ? 0.5 : 1,
        padding: '8px 12px',
        margin: '6px 0',
        background: '#f5f5f5',
        border: '1px solid #ddd',
        borderRadius: 4,
        cursor: 'move',
      }}
    >
      {text}
    </div>
  );
}

export default function DragDemo({ initialItems = ['Alpha', 'Bravo', 'Charlie', 'Delta'] }) {
  const [items, setItems] = useState(initialItems);

  const moveItem = useCallback((from, to) => {
    setItems((prev) => {
      const copy = [...prev];
      const [moved] = copy.splice(from, 1);
      copy.splice(to, 0, moved);
      return copy;
    });
  }, []);

  return (
    <DndProvider backend={HTML5Backend}>
      <div style={{ maxWidth: 480, margin: '24px auto', fontFamily: 'sans-serif' }}>
        <h3 style={{ marginBottom: 12 }}>React DnD — Reorder Demo</h3>
        <div>
          {items.map((t, i) => (
            <DraggableItem key={t} id={t} text={`${i + 1}. ${t}`} index={i} moveItem={moveItem} />
          ))}
        </div>
      </div>
    </DndProvider>
  );
}
